import * as yup from "yup";

// export interface ILoi {
//     date_Of_joining: Date;
//     selection_Term: number;
//     offered_Salary: number;
//     shift_type: number;
//     subject: string;
//     basicSalary?: number;
//     basicSalaryForPf?: number;
//     employeePF?: number;
//     employerPF?: number;
//     esicEmployee?: number;
//     esicEmployer?: number;
//     monthlyCTC?: number;
//     annualCTC?: number;
//     netTakeHomeSalary?: number;
//     esicApplicable?: boolean;
//     mealAllowance?: number;
//     transportAllowance?: number;
//     healthInsurance?: number;
//     hra: number;
//     conveyance: number;
//     employement_Type?: string;
//     intern_Payment_Type?: string;
// }

export interface ILoi {
    date_Of_joining: Date;
    selection_Term: number;
    offered_Salary?: number;
    shift_type: number;
    subject: string;

    basicSalary?: number;
    basicSalaryForPf?: number;
    employeePF?: number;
    employerPF?: number;
    esicEmployee?: number;
    esicEmployer?: number;

    monthlyCTC?: number;
    annualCTC?: number;
    netTakeHomeSalary?: number;
    esicApplicable?: boolean;

    mealAllowance?: number;
    transportAllowance?: number;
    healthInsurance?: number;

    hra?: number;
    conveyance?: number;

    employement_Type?: "EMPLOYEE" | "INTERN";
    intern_Payment_Type?: "PAID" | "UNPAID" | "";
}

export const schema = yup.object({
    date_Of_joining: yup.date().required("Joining date is required"),
    selection_Term: yup.number().required("Job type is required"),

    employement_Type: yup.string().oneOf(["EMPLOYEE", "INTERN"]).required("Employment type is required"),
    intern_Payment_Type: yup.string().when("employement_Type", {
        is: (val: string) => val === "INTERN",
        then: (schema) =>
            schema.required("Intern payment type is required"),
        otherwise: (schema) =>
            schema.strip(),
    }),

    offered_Salary: yup.number().when(["employement_Type", "intern_Payment_Type"], {
        is: (type: string, internType: string) => type === "EMPLOYEE" || internType === "PAID",
        then: (schema) => schema.typeError("Salary must be a number").required("Salary is required"),
        otherwise: (schema) => schema.strip(),
    }
    ),

    shift_type: yup.number().required("Shift type is required"),
    subject: yup.string().required("Subject is required"),

});